<template>
	<div class="d-flex align-center justify-start">
		<div v-for="(association, index) in mappedProjectLineAssociations" :key="index">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						icon
						x-small
						color="success"
						class="mb-0 caption font-weight-bold px-0"
						v-bind="attrs"
						v-on="on"
						@click="handleGoTo(association)">
							<v-icon small>{{getAssociationIcon(association.morphable_type)}}</v-icon>
					</v-btn>
				</template>
				<span>{{getAssociationType(association.morphable_type)}}</span>
			</v-tooltip>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProjectLineAssociationIcons',
	props: {
		projectLineAssociations: {
			type: Object,
			default: null
		},
		btnClick: {
			type: Function
		}
	},
	computed: {
		mappedProjectLineAssociations(){
			if(this.projectLineAssociations?.associations){
				return this.projectLineAssociations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
	},
	methods:{
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		getAssociationIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-home-edit-outline'
				default:
					return 'Otro'
			}
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
	}
}
</script>

<style>

</style>